
import React from 'react';
import { Text, Heading, Autocomplete } from 'base-ui'
import { PageWrapper } from './PageWrapper';
import CodeSampleSelector from './CodeSampleSelector'
import { Autocomplete as AutocompleteExample } from '../examples/Autocomplete'

interface IOptions{
    label: string,
    value: string,
    key?: string | number
}

export default function AutocompleteDemo() {
    const defaultValue = '3';
    
    const options: IOptions[] = [
        {
            "key": 1,
            "label": "Leanne Graham",
            "value": "1"
        },
        {
            "key": 2,
            "label": "Ervin Howell",
            "value": "2"
        },
        {
            "key": 3,
            "label": "Clementine Bauch",
            "value": "3"
        },
        {
            "key": 4,
            "label": "Patricia Lebsack",
            "value": "4"
        },
        {
            "key": 5,
            "label": "Chelsey Dietrich",
            "value": "5"
        },
        {
            "key": 6,
            "label": "Mrs. Dennis Schulist",
            "value": "6"
        },
        {
            "key": 7,
            "label": "Kurtis Weissnat",
            "value": "7"
        },
        {
            "key": 8,
            "label": "Nicholas Runolfsdottir V",
            "value": "8"
        },
        {
            "key": 9,
            "label": "Glenna Reichert",
            "value": "9"
        },
        {
            "key": 10,
            "label": "Clementina DuBuque",
            "value": "10"
        }
    ];

    const onChange = (searchText: any) => {
        console.log(searchText)
    }

    const onSelect = (selectedOption: IOptions) => {
        console.log(selectedOption)
    }

    return (
        <PageWrapper title="AutoComplete">
            <Text size="lg">
                The AutoComplete component allows users to pick a value from predefined set of options.
                It also allow searchable selection.
            </Text>
            <div className="py-2">
                <Autocomplete 
                    label={'Autocomplete'}
                    options={options}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onSelect={onSelect}
                />
            </div>
            <div className="py-2">
                <Autocomplete 
                    label={'Disabled Autocomplete'}
                    options={options}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onSelect={onSelect}
                    disabled={true}
                />
            </div>
            <div className="py-2">
                <Autocomplete
                    label={'Autocomplete with error'}
                    options={options}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onSelect={onSelect}
                    isInvalid={true}
                    isInvalidText={'Please enter a valid name'}
                />
            </div>
            {/* Commenting this out in the docs since we are not currently using different sizes and the styling does not align with design system */}
            {/* <Heading size="h3">Size</Heading>
            <Text size="lg">By default the size is 'md'. Use the 'size' prop for bigger Autocomplete fields.</Text>
            <div className="py-2">
                <Autocomplete
                    label={'Autocomplete'}
                    options={options}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onSelect={onSelect}
                    size="lg" // md, lg
                />
            </div> */}
            <Heading size="h3">Usage</Heading>

            <CodeSampleSelector
                baseUi={AutocompleteExample}
                algoliaUi={`TBD`}
            />
        </PageWrapper>
    )
}